/* JALA HEAD SPA — theme interactions (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ICON = {
    google: '<svg viewBox="0 0 48 48" aria-label="Google"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>',
    fresha: '<svg viewBox="0 0 48 48" aria-label="Fresha"><circle cx="24" cy="24" r="22" fill="#0B0B0B"/><path fill="#fff" d="M18 13h14v4.5h-9.2V22H31v4.5h-8.2V35H18z"/></svg>'
  };

  /* Reveal on scroll ---------------------------------------------------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  const observeReveals = (root = document) => $$('[data-reveal]:not(.is-in)', root).forEach((el) => io.observe(el));
  observeReveals();

  /* Header -------------------------------------------------------------- */
  const header = $('[data-header]');
  const bookbar = $('[data-bookbar]');
  let lastY = 0;
  const onScroll = () => {
    const y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 40);
    if (bookbar) {
      const nearEnd = window.innerHeight + y > document.body.scrollHeight - 300;
      bookbar.classList.toggle('is-visible', y > window.innerHeight * 0.7 && !nearEnd);
    }
    lastY = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Mobile drawer ------------------------------------------------------- */
  $$('[data-menu-toggle]').forEach((b) => b.addEventListener('click', () => {
    const open = document.documentElement.classList.toggle('is-menu-open');
    $$('[data-menu-toggle]').forEach((x) => x.setAttribute('aria-expanded', open));
    document.body.style.overflow = open ? 'hidden' : '';
  }));
  $$('.drawer a').forEach((a) => a.addEventListener('click', () => {
    document.documentElement.classList.remove('is-menu-open');
    document.body.style.overflow = '';
  }));

  /* Component init (re-run for sections reloaded in the theme editor) */
  const init = (scope = document) => {
    /* Announcement rotator ------------------------------------------------ */
    $$('[data-announce]', scope).forEach((bar) => {
      const items = $$('.announce__item', bar);
      if (items.length < 2) return;
      let i = 0;
      setInterval(() => {
        const cur = items[i];
        cur.classList.remove('is-active'); cur.classList.add('is-leaving');
        setTimeout(() => cur.classList.remove('is-leaving'), 600);
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, parseInt(bar.dataset.speed || 4500, 10));
    });

    /* Parallax (hero + split images) ------------------------------------- */
    if (!reduce) {
      const px = $$('[data-parallax]', scope);
      const tick = () => {
        const vh = window.innerHeight;
        px.forEach((el) => {
          const r = el.parentElement.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          const p = (r.top + r.height / 2 - vh / 2) / vh;
          const amt = parseFloat(el.dataset.parallax || 0.08);
          el.style.transform = `translate3d(0,${(p * amt * 100).toFixed(2)}px,0) scale(1.12)`;
        });
        requestAnimationFrame(tick);
      };
      if (px.length) requestAnimationFrame(tick);
    }

    /* Hero bubbles (canvas) ---------------------------------------------- */
    $$('[data-bubbles]', scope).forEach((cv) => {
      if (reduce) return;
      const ctx = cv.getContext('2d');
      let w, h, dpr, bubbles = [];
      const mouse = { x: -999, y: -999 };
      const resize = () => {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        w = cv.offsetWidth; h = cv.offsetHeight;
        cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const n = Math.round(Math.min(46, w / 28));
        bubbles = Array.from({ length: n }, () => ({
          x: Math.random() * w, y: h + Math.random() * h, r: 2 + Math.random() * 9,
          s: 0.25 + Math.random() * 0.7, o: Math.random() * Math.PI * 2, a: 0.15 + Math.random() * 0.35
        }));
      };
      cv.parentElement.addEventListener('pointermove', (e) => {
        const r = cv.getBoundingClientRect(); mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
      });
      const draw = () => {
        ctx.clearRect(0, 0, w, h);
        bubbles.forEach((b) => {
          b.y -= b.s; b.o += 0.012; b.x += Math.sin(b.o) * 0.35;
          const dx = b.x - mouse.x, dy = b.y - mouse.y, d = Math.hypot(dx, dy);
          if (d < 110) { b.x += dx / d * 1.6; b.y += dy / d * 1.6; }
          if (b.y < -20) { b.y = h + 20; b.x = Math.random() * w; }
          const g = ctx.createRadialGradient(b.x - b.r / 3, b.y - b.r / 3, 0, b.x, b.y, b.r);
          g.addColorStop(0, `rgba(255,255,255,${b.a})`); g.addColorStop(0.7, `rgba(255,255,255,${b.a * 0.25})`); g.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.beginPath(); ctx.fillStyle = g; ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2); ctx.fill();
          ctx.strokeStyle = `rgba(255,255,255,${b.a * 0.6})`; ctx.lineWidth = 0.6; ctx.stroke();
        });
        requestAnimationFrame(draw);
      };
      resize(); window.addEventListener('resize', resize); requestAnimationFrame(draw);
    });

    /* Count-up stats ------------------------------------------------------ */
    const countIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        countIO.unobserve(e.target);
        const el = e.target, end = parseFloat(el.dataset.count), dec = (el.dataset.count.split('.')[1] || '').length;
        if (reduce) { el.textContent = end.toLocaleString('en-AU', { minimumFractionDigits: dec }); return; }
        const t0 = performance.now(), dur = 1800;
        const step = (t) => {
          const p = Math.min(1, (t - t0) / dur), v = end * (1 - Math.pow(1 - p, 4));
          el.textContent = v.toLocaleString('en-AU', { minimumFractionDigits: dec, maximumFractionDigits: dec });
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    $$('[data-count]', scope).forEach((el) => countIO.observe(el));

    /* Specials: filter chips + spotlight/tilt ---------------------------- */
    $$('[data-specials]', scope).forEach((root) => {
      const cards = $$('.special', root);
      $$('[data-filter]', root).forEach((chip) => chip.addEventListener('click', () => {
        $$('[data-filter]', root).forEach((c) => c.classList.toggle('is-active', c === chip));
        const f = chip.dataset.filter;
        cards.forEach((c) => c.classList.toggle('is-hidden', f !== 'all' && !(c.dataset.tags || '').split(',').includes(f)));
      }));
    });
    if (!reduce && window.matchMedia('(hover:hover)').matches) {
      $$('[data-tilt]', scope).forEach((el) => {
        el.addEventListener('pointermove', (e) => {
          const r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          el.style.setProperty('--mx', `${x * 100}%`); el.style.setProperty('--my', `${y * 100}%`);
          el.style.transform = `perspective(900px) rotateX(${(0.5 - y) * 6}deg) rotateY(${(x - 0.5) * 6}deg) translateY(-6px)`;
        });
        el.addEventListener('pointerleave', () => { el.style.transform = ''; });
      });
    }

    /* Reviews wall -------------------------------------------------------- */
    const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const initials = (n) => String(n || '?').trim().split(/\s+/).map((p) => p[0]).slice(0, 2).join('').toUpperCase();
    const fmtDate = (d) => {
      if (!d) return '';
      const dt = new Date(d); if (isNaN(dt)) return esc(d);
      const days = Math.round((Date.now() - dt) / 864e5);
      if (days < 1) return 'Today'; if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`;
      if (days < 31) return `${Math.round(days / 7)} week${days >= 14 ? 's' : ''} ago`;
      return dt.toLocaleDateString('en-AU', { month: 'short', year: 'numeric' });
    };
    const reviewHTML = (r, n = 0) => `
      <article class="review" style="--n:${n % 12}">
        <div class="review__head">
          <span class="review__avatar">${esc(initials(r.n))}</span>
          <div><div class="review__name">${esc(r.n)}</div><div class="review__date">${fmtDate(r.d)}</div></div>
          <span class="review__src" title="${r.s === 'google' ? 'Google review' : 'Fresha review'}">${ICON[r.s] || ICON.fresha}</span>
        </div>
        <div class="stars" aria-label="${r.r || 5} out of 5 stars">${'★'.repeat(r.r || 5)}${'☆'.repeat(5 - (r.r || 5))}</div>
        <p class="review__text">${esc(r.t)}</p>
        ${r.w ? `<span class="review__therapist">with ${esc(r.w)}</span>` : ''}
      </article>`;

    $$('[data-reviews]', scope).forEach((root) => {
      let inline = [];
      try { inline = JSON.parse($('[data-reviews-inline]', root)?.textContent || '[]'); } catch (e) { /* noop */ }
      const all = [...inline, ...(window.JALA_REVIEWS || [])]
        .filter((r) => r && r.t && (r.r || 5) >= parseInt(root.dataset.minStars || 1, 10))
        .sort((a, b) => (new Date(b.d || 0)) - (new Date(a.d || 0)));
      const layout = root.dataset.layout || 'wall';
      const pageSize = parseInt(root.dataset.pageSize || 12, 10);
      const wall = $('[data-reviews-wall]', root);
      const moreBtn = $('[data-reviews-more]', root);
      const countEl = $('[data-reviews-count]', root);
      let src = root.dataset.source || 'all', q = '', shown = 0, list = all;

      if (layout === 'rows') {
        const pool = all.slice(0, 40);
        if (!pool.length) { wall.innerHTML = '<p class="reviews__empty">Add reviews to see them here.</p>'; return; }
        const half = Math.ceil(pool.length / 2);
        const row = (items, rev) => `<div class="review-row${rev ? ' review-row--rev' : ''}" style="--speed:${items.length * 7}s">${[...items, ...items].map((r) => reviewHTML(r)).join('')}</div>`;
        wall.innerHTML = row(pool.slice(0, half), false) + (pool.length > 3 ? row(pool.slice(half), true) : '');
        return;
      }

      const apply = () => {
        const needle = q.toLowerCase();
        list = all.filter((r) => (src === 'all' || r.s === src) && (!needle || `${r.t} ${r.n} ${r.w || ''}`.toLowerCase().includes(needle)));
        shown = 0; wall.innerHTML = ''; more();
      };
      const more = () => {
        const next = list.slice(shown, shown + pageSize);
        if (!list.length) wall.innerHTML = '<p class="reviews__empty">No reviews match that search — try another word.</p>';
        wall.insertAdjacentHTML('beforeend', next.map((r, i) => reviewHTML(r, i)).join(''));
        shown += next.length;
        if (moreBtn) moreBtn.hidden = shown >= list.length;
        if (countEl) countEl.textContent = list.length ? `Showing ${shown} of ${list.length.toLocaleString('en-AU')}` : '';
      };
      $$('[data-src]', root).forEach((chip) => chip.addEventListener('click', () => {
        $$('[data-src]', root).forEach((c) => c.classList.toggle('is-active', c === chip));
        src = chip.dataset.src; apply();
      }));
      const search = $('[data-reviews-search]', root);
      if (search) { let t; search.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => { q = search.value.trim(); apply(); }, 200); }); }
      if (moreBtn) moreBtn.addEventListener('click', more);
      // infinite load when the button scrolls into view
      if (moreBtn && 'IntersectionObserver' in window && root.dataset.infinite === 'true') {
        new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && !moreBtn.hidden && more()), { rootMargin: '200px' }).observe(moreBtn);
      }
      apply();
    });

    /* Treatment finder quiz ---------------------------------------------- */
    $$('[data-finder]', scope).forEach((root) => {
      let data; try { data = JSON.parse($('[data-finder-data]', root).textContent); } catch (e) { return; }
      const steps = $$('.finder__step', root), bar = $('.finder__progress span', root), result = $('[data-finder-result]', root);
      const answers = [];
      const show = (i) => {
        steps.forEach((s, j) => s.classList.toggle('is-active', j === i));
        bar.style.width = `${(i / (steps.length - 1)) * 100}%`;
      };
      $$('[data-answer]', root).forEach((btn) => btn.addEventListener('click', () => {
        const i = parseInt(btn.closest('.finder__step').dataset.step, 10);
        $$('[data-answer]', btn.parentElement).forEach((b) => b.classList.toggle('is-picked', b === btn));
        answers[i] = btn.dataset.answer;
        setTimeout(() => {
          if (i + 1 < steps.length - 1) return show(i + 1);
          // score: the time answer picks the duration, goal picks the extra
          const key = answers.join('|');
          const pick = data.rules.find((r) => r.match.every((m, k) => m === '*' || m === answers[k])) || data.rules[data.rules.length - 1];
          const t = data.treatments[pick.t] || Object.values(data.treatments)[0];
          if (!t) return;
          result.innerHTML = `
            <span class="eyebrow">Your perfect match</span>
            <h3>${esc(t.name)}</h3>
            <div class="special__meta">${esc(t.meta)}</div>
            <div class="price">$${esc(t.price)}${t.was ? ` <s>$${esc(t.was)}</s>` : ''}</div>
            <div class="finder__why">${esc(pick.why)}</div>
            <a class="btn btn--accent btn--block" href="${esc(t.url)}" target="_blank" rel="noopener">Book this ritual <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
            <button class="finder__back" data-restart>↺ Start again</button>`;
          show(steps.length - 1);
          $('[data-restart]', result).addEventListener('click', () => { answers.length = 0; $$('.is-picked', root).forEach((b) => b.classList.remove('is-picked')); show(0); });
          window.dataLayer && window.dataLayer.push({ event: 'jala_finder_result', treatment: t.name, answers: key });
        }, 260);
      }));
      $$('[data-finder-back]', root).forEach((b) => b.addEventListener('click', () => show(Math.max(0, parseInt(b.closest('.finder__step').dataset.step, 10) - 1))));
      show(0);
    });

    /* Ritual journey (scroll-synced image swap) -------------------------- */
    $$('[data-ritual]', scope).forEach((root) => {
      const steps = $$('.ritual__step', root), imgs = $$('.ritual__media img', root);
      const rio = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        const i = steps.indexOf(e.target);
        steps.forEach((s, j) => s.classList.toggle('is-active', j === i));
        imgs.forEach((im, j) => im.classList.toggle('is-active', j === Math.min(i, imgs.length - 1)));
      }), { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach((s) => rio.observe(s));
    });

    /* Countdown ----------------------------------------------------------- */
    $$('[data-countdown]', scope).forEach((el) => {
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      const parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        parts.d.textContent = pad(d); parts.h.textContent = pad(h); parts.m.textContent = pad(m); parts.s.textContent = pad(s);
        if (end - Date.now() <= 0) { const w = el.closest('[data-countdown-wrap]') || el; w.hidden = true; return; }
        setTimeout(tick, 1000);
      };
      tick();
    });

    /* Open-now indicator (uses Gold Coast time, no daylight saving) ------- */
    $$('[data-hours]', scope).forEach((root) => {
      let hours; try { hours = JSON.parse(root.dataset.hours); } catch (e) { return; }
      const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Brisbane' }));
      const day = now.getDay(); // 0 Sun
      const mins = now.getHours() * 60 + now.getMinutes();
      const toM = (t) => { const [h, m] = t.split(':').map(Number); return h * 60 + (m || 0); };
      const today = hours[day];
      $$('tr[data-day]', root).forEach((tr) => tr.classList.toggle('is-today', +tr.dataset.day === day));
      const status = $('[data-open-status]', root);
      if (!status) return;
      const label = $('span', status);
      if (today && mins >= toM(today[0]) && mins < toM(today[1])) {
        status.classList.add('is-open');
        const left = toM(today[1]) - mins;
        label.textContent = left <= 60 ? `Open · closes in ${left} min` : `Open now · until ${fmt12(today[1])}`;
      } else {
        let k = 0, nd;
        do { k++; nd = hours[(day + k) % 7]; } while (!nd && k < 7);
        const opensToday = today && mins < toM(today[0]);
        label.textContent = opensToday ? `Closed · opens ${fmt12(today[0])} today` : `Closed · opens ${k === 1 ? 'tomorrow' : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][(day + k) % 7]} ${nd ? fmt12(nd[0]) : ''}`;
      }
      function fmt12(t) { const [h, m] = t.split(':').map(Number); return `${((h + 11) % 12) + 1}${m ? ':' + String(m).padStart(2, '0') : ''}${h < 12 ? 'am' : 'pm'}`; }
    });
  };
  init();

  /* Custom cursor ------------------------------------------------------- */
  const cursor = $('[data-cursor]');
  if (cursor && !reduce && window.matchMedia('(hover:hover) and (min-width:990px)').matches) {
    let x = 0, y = 0, cx = 0, cy = 0;
    window.addEventListener('pointermove', (e) => { x = e.clientX; y = e.clientY; cursor.classList.add('is-on'); });
    document.addEventListener('pointerleave', () => cursor.classList.remove('is-on'));
    document.addEventListener('pointerover', (e) => cursor.classList.toggle('is-hover', !!e.target.closest('a,button,summary,[data-tilt]')));
    const loop = () => { cx += (x - cx) * 0.2; cy += (y - cy) * 0.2; cursor.style.transform = `translate(${cx}px,${cy}px) translate(-50%,-50%)`; requestAnimationFrame(loop); };
    loop();
  }

  /* Track booking clicks (GA4 / Meta pixel if installed) --------------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="fresha.com"]');
    if (!a) return;
    const label = a.dataset.track || a.textContent.trim().slice(0, 60);
    window.dataLayer && window.dataLayer.push({ event: 'jala_book_click', label, href: a.href });
    window.gtag && window.gtag('event', 'book_click', { label });
    window.fbq && window.fbq('track', 'Lead', { content_name: label });
  });

  /* Re-init reveals in the theme editor -------------------------------- */
  document.addEventListener('shopify:section:load', (e) => { observeReveals(e.target); init(e.target); $$('[data-reveal]', e.target).forEach((el) => el.classList.add('is-in')); });
})();
